module.exports = __webpack_public_path__ + "img/o2@2x.ddf76869.png";